export default __webpack_public_path__ + "static/media/mosiac.86e6594c.png";